<template>
    <footer id="footer">
        <p class="text-lg-right">
            &copy; {{ new Date().getFullYear() }} - <a href="https://www.castus.co.uk">Castus</a>.
        </p>
    </footer>
</template>

<script>
export default {
    name: "FooterBar"
}
</script>

<style scoped>
    #footer {
        background: #f3f5f9;
    }

    p {
        font-size: 14px;
        color: #758697;
        margin-right: 10px;
        line-height: 12px;
    }

    p a {
        color: #000;
    }

</style>
